import styled from 'styled-components';
import { EmptyButton, getTheme } from 'mol-ui';

export const Container = styled.div`
    border-right: 1px solid ${ ({ theme: { disabledColor } }) => disabledColor };
    flex: 1;
    height: 100%;
    min-width: 350px;
    position: relative;
`;

export const DateRangePickerContainer = styled.div`
    height: 40px;
    width: 100%;
`;

export const Title = styled.span`
    color: ${ getTheme('textColor') };
    font-size: 20px;
    margin-right: auto;
`;

export const Filter = styled.div`
    align-items: center;
    align-self: flex-end; 
    color: ${ getTheme('textColor') };
    cursor: pointer;
    display: flex;
    margin-top: 8px;
    font-size: .9rem;
    font-weight: 500;
    position: absolute;
    right: 0px;
`;

export const FilterBox = styled.div`
    align-items: center;
    display: flex;
    width: 100%;
`;

export const FilterContainer = styled.div`
    position: absolute;
    right: 0px;
`;

export const FooterContainer = styled.div`
    border-top: 1px solid ${ ({ theme: { primaryLighterColor } }) => primaryLighterColor };
    height: 30px;
`;

export const Header = styled.div`
    background: ${ ({ theme: { lightColor } }) => lightColor };
    border-bottom: 1px solid ${ ({ theme: { disabledColor } }) => disabledColor };
    display: flex;
    flex-direction: column; 
    flex-wrap: wrap;
    height: 140px;
    padding: 15px 15px 0px 15px;
    position: relative;
    width: 100%;
`;

export const IconContainer = styled(EmptyButton)`
    margin-left: 5px;
`;

export const IconContainerInline = styled(EmptyButton)`

`;

export const Input = styled.input`
    background: ${ ({ theme: { lightColor } }) => lightColor };
    box-shadow: none;
    border: none;
    color: ${ ({ theme: { textColor } }) => textColor };
    font-size: .9rem;
    flex-wrap: wrap;
    height: 40px;
    max-width: 150px;
    outline: none;
    padding: 10px 10px 10px 0px;
    width: 100%;
    z-index: 9997;

    &::placeholder {
        color: ${ ({ theme: { labelColor } }) => labelColor };
        font-weight: 500;
    }
`;

export const List = styled.div`
    height: calc(100% - ${ ({ hasFooter }) => !!hasFooter ? '165px' : '140px' });
    overflow: auto;
    padding: 10px;
    width: 100%;
`;

export const Row = styled.div`
    display: flex;
    flex-direction: row;
    width: 100%;
`;

export const SearchContainer = styled.div`
    align-items: center;
    display: flex;
    flex-direction: column;
    margin-top: 10px;
    position: relative;
    width: 100%;
`;
